"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEformPropertyState2 = exports.defaultEformPropertyState1 = void 0;
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
exports.defaultEformPropertyState1 = {
    property_id: 111121,
    imageUrl: 'https://images.okay.com/property/wp273_154/belleview-place-repulse-bay-for-sale-16447_638120813025520744.webp',
    title: 'Flat E, 30/F, The Repulse Bay',
    size: 9565,
    isNetSize: true,
    beds: 3,
    bath: 3,
    price: 15000000,
    type: SfilterTypeGroup_1.ListingPurposeType.Sale,
    buildingName: 'The Repulse Bay',
    address: '13 Repulse Bay Road',
    caption: 'Flat E, 30/F'
};
exports.defaultEformPropertyState2 = {
    property_id: 123456,
    imageUrl: 'https://images.okay.com/property/wp273_154/le-palais-tai-tam-for-sale-17315_638086135177026682.webp',
    title: 'Unit B, Blk 10, South Horizon Drive House',
    size: 1234,
    isNetSize: true,
    beds: 4,
    bath: 2,
    price: 24000,
    type: SfilterTypeGroup_1.ListingPurposeType.Rent,
    buildingName: 'South Horizons',
    address: 'South Horizon Drive House',
    caption: 'Unit B, Blk 10'
};
